module.exports = __webpack_public_path__ + "static/media/piece.c9c99942.png";